import { gql } from '../../__generated__/gql'

export const SIGN_UP_MUTATION = gql(`
  mutation signUp(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $organization: String!
    $planId: Int!
    $zipCode: String!
    $couponCode: String
    $stripeCardToken: String!
    $primaryInstrumentId: Int
    $recaptchaToken: String
    $mobileAppToken: String
    $overridePendingInvitation: Boolean
  ) {
    signUp(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        organization: $organization
        planId: $planId
        zipCode: $zipCode
        couponCode: $couponCode
        stripeCardToken: $stripeCardToken
        primaryInstrumentId: $primaryInstrumentId
        recaptchaToken: $recaptchaToken
        mobileAppToken: $mobileAppToken
        overridePendingInvitation: $overridePendingInvitation
      }
    ) {
      user {
        ...userProfileFields
      }
    }
  }
`)
